module.exports = __webpack_public_path__ + "media/images/dog-3a6a822716e3ace860af9d723ea0faf6.jpg";